'use client'
import { FC, useState, PropsWithChildren } from 'react'
import { SailPackageContext } from './SailPackageContext'
import { SailPackage } from '@/root/shared-types'

export const SailPackageProvider: FC<PropsWithChildren<Record<string, unknown>>> = ({ children }) => {
  const [sailPackage, setSailPackage] = useState<SailPackage>()

  return <SailPackageContext.Provider value={{ sailPackage, setSailPackage }}>{children}</SailPackageContext.Provider>
}
